export default __webpack_public_path__ + "static/media/concrete-saver-6700.2f58e42e.png";